import { CalendarTaskCategoryEditItem, ICalendarTaskCategoryEditItem } from "./calendarTaskCategoryEditItem";

export interface ICalendarTaskCategoryEdit {
    item: ICalendarTaskCategoryEditItem;
}

export class CalendarTaskCategoryEdit implements ICalendarTaskCategoryEdit {
    item: CalendarTaskCategoryEditItem;

    constructor();
    constructor(obj: ICalendarTaskCategoryEdit);
    constructor(obj?: any) {
        this.item = new CalendarTaskCategoryEditItem(obj ? obj.item : null);
    }
}